// project import
import Pages from "./pages";
import home from "./home";
import admin from "./admin";
import authentication from "./authentication";
import support from "./support";
import crops from './crops'
import ddpsPages from "./ddps-items";
import dynamicweedpages from './weeds'
import ddpsHome from "./ddps-home";

// ==============================|| MENU ITEMS ||============================== //
const menuItems = {
  items: [ddpsHome, home,admin,crops ,dynamicweedpages , authentication,support, ddpsPages]
};

export default menuItems;
